import React from "react";

const Testmonials = () => {
	return <section id="testmonials"></section>;
};

export default Testmonials;
